import { Component, HostBinding, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { getMenuLabel, isImageIcon, isLucideIcon, lucideIconName } from '@core/utils';
import { MenuActionService } from 'app/helpers/menu-action.service';

@Component({
    selector: '[core-menu-horizontal-item]',
    templateUrl: './item.component.html',
    standalone: false
})
export class CoreMenuHorizontalItemComponent {
  @Input()
  item: any;

  /** Expone el helper al template: el icono puede ser clase o imagen */
  readonly isImageIcon = isImageIcon;

  /** Los iconos elegidos del catálogo se guardan como 'lucide:<nombre>' */
  readonly isLucideIcon = isLucideIcon;
  readonly lucideIconName = lucideIconName;

  constructor(private _translateService: TranslateService,
              private _menuActionService: MenuActionService) {}

  /**
   * Ejecuta la opción de tipo acción en lugar de navegar
   * @param event Clic sobre el item
   */
  runAction(event: Event): void {
    event.preventDefault();
    this._menuActionService.run(this.item);
  }

  /** Título en el idioma activo (clave i18n o texto de la base) */
  get label(): string {
    return getMenuLabel(this.item, this._translateService);
  }
}
